export interface AppState {
  authentication: Authentication;
  loadingCount: number;
  loadingMessage: string;
  profile: UserProfileDto;
  roles: string[];
}

export interface Authentication {
  username: string;
  token: string;
}

export interface Competency {
  id: string;
  descriptionTH: string | null;
  descriptionEN: string | null;
}

export interface UpsertCompetencyRequest {
  competencies: Competency[] | null;
}

export interface GetCompetencyRequest {
  searchString: string | null;
  competencyNo: string | null;
}

export interface GetCompetencyResponse {
  competencies: Competency[] | null;
}

export interface Skill {
  id: string;
  descriptionTH: string | null;
  descriptionEN: string | null;
}

export interface UpsertSkillRequest {
  skills: Skill[] | null;
}

export interface GetSkillRequest {
  searchString: string | null;
  skillNo: string | null;
}

export interface GetSkillResponse {
  skills: Skill[] | null;
}

export enum TrainingTypeEnum {
  Internal = 0,
  External = 1,
  NewEmployee = 2,
  Transfer = 3,
  Promote = 4,
  OnTheJob = 5,
  SiteVisit = 6,
}

export interface Course {
  id: string;
  description: string | null;
  courseTypeId: string | null;
  courseType: CourseType | null;
}

export interface UpsertCourseRequest {
  courses: Course[] | null;
}

export interface UpsertCourseResponse {
  course: Course | null;
}

export interface GetCourseRequest {
  searchString: string | null;
  courseNo: string | null;
}

export interface GetCourseResponse {
  courses: Course[] | null;
}

export interface CourseType {
  id: string;
  description: string | null;
}

export interface UpsertCourseTypeRequest {
  courseTypes: CourseType[] | null;
}

export interface GetCourseTypeRequest {
  searchString: string | null;
  courseTypeNo: string | null;
}

export interface GetCourseTypeResponse {
  courseTypes: CourseType[] | null;
}

export interface GetCourseIdResponse {
  course: Course | null;
  trainingDocuments: TrainingDocument[] | null;
}
export interface Instructor {
  id: string;
  name: string | null;
  position: string | null;
  address1: string | null;
  address2: string | null;
  telNo: string | null;
  email: string | null;
  institute: string | null;
}

export interface GetInstructorRequest {
  searchString: string | null;
  instructorId: string | null;
}

export interface GetInstructorResponse {
  instructors: Instructor[] | null;
}

export interface UpsertInstructorRequest {
  instructors: Instructor[] | null;
}
export interface TrainingDocument {
  id: string | null;
  trainingType: TrainingTypeEnum;
  courseId: string | null;
  startDate: Date;
  endDate: Date;
  releaseOn: Date | null;
  releaseById: string | null;
  releaseBy: Employee | null;
  location: string | null;
  instructorId1: string | null;
  instructorId2: string | null;
  instructorId3: string | null;
  course: Course | null;
  instructorQuestionId: number | null;
  satisfactionQuestionId: number | null;
  knowledgeQuestionId: number | null;
  instructorWaitingPeriod: number | null;
  satisfactionWaitingPeriod: number | null;
  knowledgeWaitingPeriod: number | null;
  dunning1: number | null;
  dunning2: number | null;
  hours: number | null;
  time: string | null;
  instructorQuestion: Question | null;
  satisfactionQuestion: Question | null;
  knowledgeQuestion: Question | null;
  internalInstructorId1: string | null;
  internalInstructorId2: string | null;
  internalInstructorId3: string | null;
  instructor1: Instructor | null;
  instructor2: Instructor | null;
  instructor3: Instructor | null;
  internalInstructor1: Employee | null;
  internalInstructor2: Employee | null;
  internalInstructor3: Employee | null;
  cancelOn: Date | null;
  cancelById: string | null;
  cancelBy: Employee | null;
  completedOn: Date | null;
  completedById: string | null;
  completedBy: Employee | null;
  trainingTypeDescription: string | null;
  status: string | null;
  remark: string | null;
}

export interface GetTrainingDocumentRequest {
  searchString: string | null;
  trainingDocumentNo: string | null;
  fromDate: string | null;
  toDate: string | null;
}

export interface GetTrainingDocumentResponse {
  trainingDocuments: TrainingDocument[] | null;
}

export interface TrainingAttendance {
  trainingDocumentId: string | null;
  employeeId: string | null;
  instructorScore: number | null;
  satisfactionScore: number | null;
  knowledgeScore: number | null;
  supervisorComment: string | null;
  trainingDocument: TrainingDocument | null;
  employee: Employee | null;
  assessments: TrainingAssessment[] | null;
}
export interface TrainingAssessment {
  trainingDocumentId: string | null;
  employeeId: string | null;
  questionId: number | null;
  documentDate: Date | null;
  activeDate: Date | null;
  dunningDate1: Date | null;
  dunningDate2: Date | null;
  isDunning1: boolean | null;
  isDunning2: boolean | null;
  superVisorDunningDate1: Date | null;
  superVisorDunningDate2: Date | null;
  isSuperVisorDunning1: boolean | null;
  isSuperVisorDunning2: boolean | null;
  assessmentData: string | null;
  supervisorAssessmentData: string | null;
  submitOn: Date | null;
  approveOn: Date | null;
  supervisorId: string | null;
  supervisor: Employee | null;
  trainingAttendance: TrainingAttendance | null;
  question: Question | null;
  employee: Employee | null;
  employeeScore: number | null;
  supervisorScore: number | null;
  status: string | null;
}

// export interface TrainingAttendanceDto {
//   trainingDocumentId: string;
//   employeeId: string;
//   internalAssessmentData: string | null;
//   externalAssessmentData: string | null;
//   knowledgeAssessmentData: string | null;
//   User: User | null;
// }

// export interface UpsertTrainingAttendanceRequest {
//   trainingAttendances: TrainingAttendance[] | null;
// }

export interface UpsertTrainingDocumentRequest {
  trainingDocuments: TrainingDocument[] | null;
}

export interface UpsertTrainingDocumentResponse {
  trainingDocument: TrainingDocument | null;
}

export interface TrainingDetailDto {
  trainingDocument: TrainingDocument | null;
  course: Course | null;
  trainingAttendances: TrainingAttendance[] | null;
}

export interface GetTrainingAttendanceResponse {
  trainingAttendances: TrainingAttendance[] | null;
}

export interface User {
  id: string | null;
  prename: string | null;
  name: string | null;
  surname: string | null;
  fullName: string | null;
  level: string | null;
  position: string | null;
  yearOfService: number;
  divisionCode: string | null;
  divisionDescription: string | null;
  departmentCode: string | null;
  departmentDescription: string | null;
  email: string | null;
  startDate: string | null;
  endDate: string | null;
}

export interface CourseDetailDto {
  course: Course | null;
  trainingDocumentDtos: TrainingDocumentDetailDto[] | null;
}

export interface TrainingDocumentDetailDto {
  course: Course | null;
  trainingDocument: TrainingDocument | null;
  trainingAttendances: TrainingAttendance[] | null;
}

export interface TrainingAttendanceUpdateDto {
  trainingAttendancesDelete: TrainingAttendance[] | null;
  trainingAttendancesUpdate: TrainingAttendance[] | null;
}

export interface ScoreInput {
  score: ScoreEnum | null;
  reason: string | null;
}

export interface InternalTrainingDataDto {
  topic: string | null;
  date: string | null;
  location: string | null;
  name: string | null;
  position: string | null;
  employeeId: string | null;
  department: string | null;
  part2_1Score: ScoreInput | null;
  part2_1Remark: string | null;
  part2_2Score: ScoreInput | null;
  part2_2Remark: string | null;
  part2_3recommend: string | null;
  part3_1Score: ScoreInput | null;
  part3_2Opinion: string | null;
}

export enum ScoreEnum {
  lowest = 0,
  low = 1,
  medium = 2,
  high = 3,
  highest = 4,
}
export interface GetEmployeeRequest {
  searchString: string | null;
}
export interface GetEmployeeResponse {
  employees: Employee[] | null;
}
export interface Employee {
  id: string | null;
  prename: string | null;
  name: string | null;
  surname: string | null;
  level: string | null;
  position: string | null;
  yearOfService: number;
  divisionCode: string | null;
  divisionDescription: string | null;
  departmentCode: string | null;
  departmentDescription: string | null;
  email: string | null;
  startDate: string | null;
  endDate: string | null;
  groupId: string | null;
  sex: string | null;
}
//Json only no C#
export interface QuestionItem {
  item: number;
  section: string;
  question: string;
  type: QuestionItemType;
  employee: boolean;
  supervisor: boolean;
  required: boolean;
  finalScore: boolean;
  sort: number;
  choice1: string;
  choice2: string;
  choice3: string;
  choice4: string;
  correctAnswer: number;
}

export interface QuestionItemChoice {
  code: number;
  description: string;
}

//Json only no C#
export interface AssessmentItem extends QuestionItem {
  // section: string;
  // question: string;
  // type: QuestionItemType;
  // employee: boolean;
  // supervisor: boolean;
  answer: string;
  more: string;
}

export enum QuestionItemType {
  text = 1,
  scale = 2,
  scaleWithMore = 3,
  choice = 4,
}

export interface LoginRequest {
  username: string;
  password: string;
  system: string;
}

export interface LoginResponse {
  token: string;
  adUsername: string;
  employeeId: string;
  message: string;
  urlReset: string;
}
export interface Question {
  id: number;
  name: string | null;
  title: string | null;
  body: string | null;
  type: QuestionType | null;
  createDate: Date | null;
  createBy: string | null;
  updateDate: Date | null;
  updateBy: string | null;
  createByEmployee: Employee | null;
  updateByEmployee: Employee | null;
  isoDocumentNo: string | null;
}

export enum QuestionType {
  Training = 1,
  Position = 2,
}

export interface GetQuestionRequest {
  searchString: string | null;
  id: number | null;
}

export interface GetQuestionResponse {
  questions: Question[];
}

export interface UpsertQuestionRequest {
  question: Question;
}

export interface UpsertQuestionResponse {
  question: Question;
}

export interface GetWorklistRequest {
  showAll: boolean;
  numberOfDays: number;
}

export interface GetWorklistResponse {
  // trainingDocuments: TrainingAttendance[] | null;
  positionDocuments: PositionDocument[] | null;
  trainingAssessments: TrainingAssessment[] | null;
}
export interface PositionDocument {
  id: string | null;
  documentDate: Date | null;
  releaseOn: Date | null;
  releaseById: string | null;
  releaseBy: Employee | null;
  submitOn: Date | null;
  approveOn: Date | null;
  employeeId: string | null;
  supervisorId: string | null;
  type: PositionType | null;
  questionId: number | null;
  assessmentData: string | null;
  supervisorAssessmentData: string | null;
  questionData: string | null;
  supervisorQuestionData: string | null;
  dunningDate1: Date | null;
  dunningDate2: Date | null;
  isDunning1: boolean | null;
  isDunning2: boolean | null;
  superVisorDunningDate1: Date | null;
  superVisorDunningDate2: Date | null;
  isSuperVisorDunning1: boolean | null;
  isSuperVisorDunning2: boolean | null;
  employee: Employee | null;
  supervisor: Employee | null;
  question: Question | null;
  cancelOn: Date | null;
  cancelById: string | null;
  cancelBy: Employee | null;
  status: string | null;
  releaseStatus: string | null;
}

export enum PositionType {
  NewEmployee = 1,
  Promotion = 2,
  Relocate = 3,
}

export interface PositionDocumentItem {
  courseId: string;
  courseDescription: string;
  mandatory: boolean;
  sort: number;
  answer: string | null;
}

export interface UpsertTrainingAttendanceRequest {
  trainingAttendancesUpdate: TrainingAttendance[] | null;
  trainingAttendancesDelete: TrainingAttendance[] | null;
}

export interface UpsertTrainingAttendanceResponse {
  trainingAttendanceUpdateDto: TrainingAttendanceUpdateDto | null;
  errors: string[] | null;
}

export interface DeleteTrainingAttendanceRequest {
  trainingAttendances: TrainingAttendance[] | null;
}
export interface GetPositionDocumentRequest {
  fromDate: Date | null;
  toDate: Date | null;
  employeeId: string | null;
  supervisorId: string | null;
  isSubmitted: boolean;
  isApproved: boolean;
  isNotSubmitted: boolean;
  id: string | null;
}

export interface GetPositionDocumentResponse {
  positionDocuments: PositionDocument[];
}
export interface UpsertPositionDocumentRequest {
  positionDocument: PositionDocument;
}

export interface UpsertPositionDocumentResponse {
  positionDocument: PositionDocument;
}
export const positionDocumentTypes = [
  { code: 1, description: "พนักงานใหม่", enum: TrainingTypeEnum.NewEmployee },
  {
    code: 2,
    description: "พนักงานเลื่อนตำแหน่ง",
    enum: TrainingTypeEnum.Promote,
  },
  { code: 3, description: "พนักงานย้ายแผนก", enum: TrainingTypeEnum.Transfer },
];

export interface GetPdpaMessageResponse {
  message: string | null;
  updateOn: Date | null;
}

export interface UpsertPdpaMessageRequest {
  message: string | null;
  updateOn: Date | null;
  release: boolean;
}

export interface ConfigUser {
  employeeId: string | null;
  isAdmin: boolean;
  isOnTheJobAdmin: boolean;
  isPdpaAccepted: boolean;
  pdpaAcceptOn: Date | null;
  employee: Employee | null;
}

// export interface GetConfigUserRequest {}

export interface GetConfigUserResponse {
  configUsers: ConfigUser[] | null;
}
export interface UpsertConfigUserRequest {
  configUser: ConfigUser;
}
export interface UserProfileDto {
  employeeId: string;
  isAdmin: boolean;
  isOnTheJobAdmin: boolean;
  isPdpaAccepted: boolean;
  isLineLinked: boolean;
  lineRegisterLink: string;
  noApproverLevel: number;
}

export interface GetUserProfileResponse {
  profile: UserProfileDto | null;
}

export interface ConfigQuestionSet {
  trainingType: TrainingTypeEnum;
  instructorQuestionId: number | null;
  satisfactionQuestionId: number | null;
  knowledgeQuestionId: number | null;
  instructorWaitingPeriod: number | null;
  satisfactionWaitingPeriod: number | null;
  knowledgeWaitingPeriod: number | null;
  dunning1: number | null;
  dunning2: number | null;
  instructorQuestion: Question | null;
  satisfactionQuestion: Question | null;
  knowledgeQuestion: Question | null;
}

export interface GetConfigQuestionSetResponse {
  configQuestionSets: ConfigQuestionSet[] | null;
}

export interface UpsertConfigQuestionSetRequest {
  questionSets: ConfigQuestionSet[];
}
export interface CopyQuestionRequest {
  questionId: number;
  description: string | null;
}
export interface CopyQuestionResponse {
  questionId: number;
}

export interface UpsertTrainingAssessmentRequest {
  trainingAssessment: TrainingAssessment;
}

export interface OnthejobDocument {
  id: string | null;
  documentDate: Date | null;
  submittedDate: Date | null;
  location: string | null;
  courseId: string | null;
  body: string | null;
  items: OnthejobItem[] | null;
  createById: string | null;
  createBy: Employee | null;
  course: Course | null;
  cancelOn: Date | null;
  cancelById: string | null;
  cancelBy: Employee | null;
  status: string | null;
}

export interface OnthejobItem {
  onthejobDocumentId: string | null;
  employeeId: string | null;
  score: OnTheJobScoreEnum | null;
  employee: Employee | null;
}

export enum OnTheJobScoreEnum {
  R1_25 = 1,
  R26_50 = 2,
  R51_75 = 3,
  R76_100 = 4,
  Pass = 5,
  Fail = 6,
}

export interface GetOnTheJobDocumentRequest {
  fromDate: Date | null;
  toDate: Date | null;
  division: string | null;
  department: string | null;
  courseId: string | null;
  id: string | null;
}

export interface GetOnTheJobDocumentResponse {
  onTheJobDocuments: OnthejobDocument[];
  divisions: DropdownDto[];
  departments: DropdownDto[];
}

export interface UpsertOnTheJobDocumentRequest {
  document: OnthejobDocument;
}

export interface UpsertOnTheJobDocumentResponse {
  documentId: string;
}

export interface GetCourseRelationResponse {
  relations: CourseRelation[] | null;
  departments: DropdownDto[] | null;
  divisions: DropdownDto[] | null;
  positions: DropdownDto[] | null;
}

export interface CourseRelation {
  id: number;
  divisionCode: string | null;
  position: string | null;
  departmentCode: string | null;
  level: number | null;
  courseId: string | null;
  course: Course | null;
  divisionDescription: string | null;
  departmentDescription: string | null;
}

export interface DropdownDto {
  code: string | null;
  description: string | null;
}
export interface UpsertCourseRelationRequest {
  relation: CourseRelation[] | null;
  delete: boolean | null;
}

export interface DownloadOnTheJobDocumentRequest {
  documentNo: string | null;
  printScore: boolean | null;
}

export interface GetAttachmentRequest {
  documentId: string | null;
}

export interface GetAttachmentResponse {
  attachments: Attachment[];
}

export interface Attachment {
  id: number;
  documentId: string | null;
  filename: string | null;
  location: string | null;
  uploadById: string | null;
  uploadBy: Employee | null;
  uploadOn: Date | null;
  isDeleted: boolean;
}

export interface UploadAttachmentResponse {
  attachment: Attachment | null;
}

export interface DownloadAttachmentRequest {
  id: number | null;
}

export interface GetTrainingAssessmentRequest {
  employeeId: string;
  questionId: number;
  documentId: string;
}

export interface GetTrainingAssessmentResponse {
  trainingAssessment: TrainingAssessment;
}

export interface DocumentReportDto {
  date: Date | null;
  employee: Employee | null;
  supervisor: Employee | null;
  submitOn: Date;
  approveOn: Date;
  status: string | null;
  type: TrainingTypeEnum | null;
  age: number;
  key: string;
}

export interface GetAgingReportRequest {
  selectedDate: Date[] | null;
}

export interface GetAgingReportResponse {
  reports: DocumentReportDto[] | null;
}

export interface GetCourseForEmployeeRequest {
  employeeId: string | null;
}

export interface GetCourseForEmployeeResponse {
  courseIds: string[] | null;
}

export interface GetTrainingReportRequest {
  selectedDate: Date[] | null;
  questionId: number | null;
  employeeId: string | null;
  courseId: string | null;
}

export interface GetIndividualEmployeeRequest {
  id: string;
}

export interface GetIndividualEmployeeResponse {
  employee: Employee;
  trainingDocuments: TrainingDocument[];
  positionDocuments: PositionDocument[];
  photo: string;
}

export interface CancelTrainingDocumentRequest {
  trainingDocumentId: string | null;
}

export interface CancelPositionDocumentRequest {
  id: string | null;
}
export interface DownloadTrainingAttendanceRequest {
  id: string | null;
}
export interface CancelOnTheJobDocumentRequest {
  id: string | null;
}
export interface AppParameterDto {
  noApproverLevel: number;
}
export interface UpsertAppParameterRequest {
  parameter: AppParameterDto | null;
}

export interface DeleteQuestionRequest {
  questionId: number;
}
export interface DownloadEmployeeHistoryRequest {
  employeeId: string;
}
export interface ValidateCaptchaRequest {
  token: string;
}

export interface ValidateCaptchaResponse {
  success: boolean;
  challenge_ts: string | null;
  hostname: string | null;
  "error-codes": string[] | null;
}

export interface NotificationLog {
  id: number;
  notificationOn: Date;
  userId: string;
  message: string;
  apiResponse: string | null;
}

export interface GetNotificationLogRequest {
  dates: Date[] | null;
  userId: string | null;
}

export interface GetNotificationLogResponse {
  logs: NotificationLog[] | null;
}
